import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import CustomButton from "../../../components/ui/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { getQuotaDetailsData, setState } from "../analyzeSlice";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Alert from "../../../components/ui/Alert";
import { setSaveDashboardFormState } from "../../../store/globalSlice";
import { store } from "../../../store/store";

const width = 220;
const height = 35;

export default function Form() {
	const dispatch = useDispatch();
	const location = useLocation();
	const {
		countries,
		selectedCountry,
		selectedCountryID,
		durations,
		duration,
		redirectedFromDashboard,
	} = useSelector((store) => store.analyze);
	// these variables are used as payload of the getQuotaDetailsData
	// previously used redux state as payload but because of the delay 
	// in updating state payload was not getting populated
	// 	let pcategory = "";
	//   let pcountryid = -500;
	//   let pduration = "";	
	const [pCategory, setPCategory] = useState("");
	const [pCountryId, setPCountryId] = useState(null);
	const [pCountryName, setPCountryName] = useState("");
	const [pDuration, setPDuration] = useState("");

  const { routeHistory } = useSelector(store => store.global);


	const [alert, setAlert] = useState({
		alertSeverity: "",
		alertDisplay: false,
		alertMessage: "",
	});

  useEffect(() => {
    if (redirectedFromDashboard) {
      dispatch(setSaveDashboardFormState(true));
    }
  }, []);

	useEffect(() => {
		// console.log("redirectedFromDashboard", redirectedFromDashboard, new Date(Date.now()));
		if (redirectedFromDashboard) {
			setDropdownsWhenRedirected();
		}
		// else{
		// 	dispatch(setState("selectedCountry", ""));
		// 	dispatch(setState("selectedCountryID", ""));
		// 	dispatch(setState("duration", null));
		// }
		dispatch(setState("quotaDetailsDataPrepared", null));
		dispatch(setState("redirectedFromDashboard", false));
	}, []);

	function setDropdownsWhenRedirected() {
		const { selectedCountry, selectedCountryID, duration, category } =
			location.state;
		// console.log(selectedCountry, selectedCountryID, duration, category);
		dispatch(setState("selectedCountry", selectedCountry));
		dispatch(setState("selectedCountryID", selectedCountryID));
		dispatch(setState("duration", duration));
		setPCategory(category);
		setPCountryId(selectedCountryID);
		setPCountryName(selectedCountry);
		setPDuration(duration);


		const obj = {
			countryID: selectedCountryID,
			duration: duration,
			category: category,
		};
		// dispatch(setState("clearAnalyzeQuotaDetails", true));
		dispatch(getQuotaDetailsData(obj));

		
	}

	function setCountry(event) {
		const name = event.target.value;
		const countryID = countries.find(
			(country) => country.countryName === name
		).countryID;

		dispatch(setState("selectedCountry", name));
		dispatch(setState("selectedCountryID", countryID));
		setPCountryId(countryID)
		setPCountryName(name);
	}

	function setDuration(event) {
		const d = event.target.value;
		let val = d.trim();
		// console.log(val);
		dispatch(setState("duration", val));
		setPDuration(val);
	}

	function handleSearch() {

		if (pCountryId === null || pCountryId === "") {
			displayAlert("Country");
			return;
		}
		if (pDuration === null || pDuration === "") {
			displayAlert("Month");
			return;
		}

		const obj = {
			countryID: pCountryId,
			duration: pDuration,
			category: "",
		};

		// dispatch(setState("clearAnalyzeQuotaDetails", true));
		dispatch(getQuotaDetailsData(obj));
	}

	const displayAlert = (severityType) => {
		setAlert({
			alertSeverity: "warning",
			alertDisplay: true,
			alertMessage: `Please select the ${severityType}`,
		});

		setTimeout(() => {
			clearAlert();
		}, [2000]);
	};

	const clearAlert = () => {
		setAlert({
			alertSeverity: "",
			alertDisplay: false,
			alertMessage: ``,
		});
	};

	return (
		<Grid container columns={12} columnSpacing={4} sx={{ mt: 2 }}>
			<Grid item>
				<FormControl
					sx={{
						height: height,
						width: width,
						color: "black.main",
					}}
				>
					<InputLabel shrink={pCountryName}>Country</InputLabel>
					<Select value={pCountryName || ""} notched label="Country" onChange={setCountry}>
						{countries?.map((country, index) => {
							return (
								<MenuItem key={index} value={country?.countryName}>
									{country.countryName}
								</MenuItem>
							);
						})}
					</Select>
				</FormControl>
			</Grid>

			<Grid item>
				<FormControl
					sx={{
						height: height,
						width: width,
						color: "black.main",
					}}
				>
					<InputLabel shrink={pDuration}>Month</InputLabel>
					<Select
						value={pDuration || ""}
						label="Month"
						onChange={setDuration}
					>
						{durations?.map((duration, index) => {
							return (
								<MenuItem key={index} value={duration?.value}>
									{duration.value}
								</MenuItem>
							);
						})}
					</Select>
				</FormControl>
			</Grid>
			<Grid item>
				<CustomButton sx={{ mt: 0.5 }} onClick={handleSearch}>
					Search
				</CustomButton>
			</Grid>
			{alert.alertDisplay && (
				<Alert message={alert.alertMessage} severity={alert.alertSeverity} />
			)}
		</Grid>
	);
}
